enum UserTaskState {
    Open = 0,
    Ongoing = 1,
    Finished = 2,
}

export default UserTaskState;